module.exports = __webpack_public_path__ + "public/img/logo.714f3e6d.png";